import {PartnerSavePartnerPersonPayload} from './partnerSavePartnerPerson.payload';
import {PartnerSavePartnerAddressPayload} from './partnerSavePartnerAddress.payload';
import {PartnerSaveAdditionalPropertyPayload} from './partnerSaveAdditionalProperty.payload';
import {MarketingChannelSavePayload} from '../../../../../marketing/channel/api/service/marketingChannelSave.payload';
import {Payload} from '../../../../../core/service/payload/payload';
import {PhoneSavePayload} from '../../../../../common/phone/payload/phoneSave.payload';

export class PartnerSavePayload implements Payload{
    partnerTypeValue: string;
    name: string;
    businessNumber: string;
    taxable: boolean;
    officeId: number;
    email: string;
    phone: PhoneSavePayload;
    vatRegimeValue: string;
    officePhone: PhoneSavePayload;
    mobilePhone: PhoneSavePayload;
    website: string;
    parents: PartnerSaveParentPayload[] = [];


    partnerPerson: PartnerSavePartnerPersonPayload;

    addresses: PartnerSavePartnerAddressPayload[] = [];
    additionalProperties: PartnerSaveAdditionalPropertyPayload[] = [];
    additionalPartnerTypes: string[];
    marketingChannels: MarketingChannelSavePayload[];
    note: string;
}

export class PartnerSaveParentPayload implements Payload{
    typeValue: string;
    partnerId: number;
}
